class WidgetPartnerCarousel {
	constructor() {
		this.timer = null;
		this.$carousel = jQuery('.partners-carousel');
		this.$currentSlide = null;
		this.isActive = true;
		this.isVisible = null;
	}

	init() {
		const self = this;

		if (this.$carousel.length !== 0) {
			this.isVisible = self.isScrolledIntoView(self.$carousel);

			//Check if element is visible in viewport
			jQuery(document).on('scroll', function () {
				this.isVisible = self.isScrolledIntoView(self.$carousel);
			});

			window.onfocus = function () {
				self.isActive = true;
			};

			window.onblur = function () {
				self.isActive = false;
			};

			this.startInterval();

			//Pause carousel if mouse enter the carousel
			this.$carousel.on('mouseenter', function () {
				clearInterval(self.timer);
			});

			//Restart interval if mouse leave the carousel
			this.$carousel.on('mouseleave', function () {
				self.startInterval();
			});
		}
	}

	startInterval() {
		const self = this;
		this.timer = setInterval(function () {
			self.slideInterval(self);
		}, 4000);
	}

	slideInterval(self) {
		//Slide animation
		self.$carousel.each(function () {
			if (jQuery(this).children('.partner-carousel-wrapper').length > 1) {
				const $el = jQuery(this).children('.partner-carousel-wrapper').first();

				$el.animate(
					{
						'margin-left': '-100%',
					},
					1000,
					function () {
						const $parent = $el.parent();
						$el.remove();
						$el.css('margin-left', 0);
						$parent.append($el);
					},
				);
			}
		});
	}

	isScrolledIntoView(el) {
		const docViewTop = jQuery(window).scrollTop();
		const docViewBottom = docViewTop + jQuery(window).height();
		const elemTop = jQuery(el).offset().top;
		return elemTop <= docViewBottom && elemTop >= docViewTop;
	}
}

const instance = new WidgetPartnerCarousel();
export default instance;
